import { call, select, takeEvery } from 'redux-saga/effects';
import { fetchEntity } from '@classpass/saga-tools';

import { selectRouteParams, selectActiveVenueId, selectUserHasPermission } from 'selectors/general';
import { PERMISSION } from 'constants/logic';
import { makePath } from 'helpers/link-generation';
import { waitForAppInit } from 'features/App/App.saga';

import { reportsTransactions as reportsTransactionsEntity } from 'store/saga/entities/bound';
import { selectPayoutTransactionControls } from './PayoutTransaction.selectors';

import { CHANGE_PAGE } from './PayoutTransaction.reducers';

export const TRANSACTION_TYPE = {
  reservations: 'RESERVATION',
  adjustments: 'ADJUSTMENT',
};

export function* handleRouteEnter(dependencies, page = 0) {
  yield call(waitForAppInit);
  const canSeePage = yield select(selectUserHasPermission, PERMISSION.DISPLAY_RATE);

  if (!canSeePage) {
    return yield call(dependencies.navigate, makePath.reports(), { replace: true });
  }

  const venueId = yield select(selectActiveVenueId);
  const { transactionType, payoutId } = yield select(selectRouteParams);

  yield call(fetchEntity, reportsTransactionsEntity, [
    dependencies,
    venueId,
    payoutId,
    TRANSACTION_TYPE[transactionType],
    page,
  ]);
}

export function* handleEntityCall(dependencies) {
  const venueId = yield select(selectActiveVenueId);
  const { payoutId, transactionType } = yield select(selectRouteParams);
  const params = yield select(selectPayoutTransactionControls);

  yield call(fetchEntity, reportsTransactionsEntity, [
    dependencies,
    venueId,
    payoutId,
    TRANSACTION_TYPE[transactionType],
    params.page - 1,
  ]);
}

export function* watchActions(dependencies) {
  yield takeEvery(CHANGE_PAGE, handleEntityCall, dependencies);
}
